import React from "react"

const _safeTrack = eventPayload => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(eventPayload)
  } else {
    console.log("dataLayer:", "non existent")
  }
}

export const useTrackFormStepArrival = stepName => {
  React.useEffect(() => {
    _safeTrack({
      event: "form_step",
      form_type: "self-schedule",
      form_step: stepName,
    })
  }, [stepName])
}

export const trackFormSubmitSuccess = () => {
  _safeTrack({
    event: "form_complete",
    form_type: "self-schedule",
  })
}

// The self-enroll steps change the URL with history.replaceState, which bypasses
// Gatsby's router — so gatsby-plugin-google-tagmanager's onRouteUpdate never runs
// and no pageview fires for steps after the initial load. Re-emitting the plugin's
// `gatsby-route-change` event here restores a GA pageview for each step using the
// same GTM trigger the rest of the site already relies on.
// NOTE: this event name must match the plugin's `routeChangeEventName` option
// (default "gatsby-route-change") in gatsby-config.js.
export const trackVirtualPageView = () => {
  _safeTrack({ event: "gatsby-route-change" })
}
